import React from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { Clock } from 'lucide-react';
import { TimeEntryActions } from './TimeEntryActions';

export const AdminActiveTimers = ({ entries, onEdit, onDelete }) => {
  const { t } = useTranslation();
  const active = entries.filter(entry => !entry.end_time);
  if (!active.length) return null;
  return (
    <section className="space-y-3" data-testid="admin-active-timers">
      <h2 className="text-base font-bold flex items-center gap-2"><Clock className="w-4 h-4 text-amber-600" />{t('timeCorrection.activeTimers')}</h2>
      {active.map(entry => (
        <div key={entry.id} className="flex flex-wrap items-center justify-between gap-3 p-3 border border-amber-200 bg-amber-50 rounded-lg" data-testid={`admin-active-entry-${entry.id}`}>
          <div className="min-w-0">
            <p className="font-semibold text-sm break-words">{entry.user_name}</p>
            <p className="text-xs text-amber-800">{format(new Date(entry.start_time), 'dd.MM.yyyy HH:mm')} · {entry.is_paused ? t('timer.paused') : t('timer.running')}</p>
          </div>
          <TimeEntryActions entry={entry} prefix="admin-active" onEdit={onEdit} onDelete={onDelete} />
        </div>
      ))}
    </section>
  );
};